import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Store} from '@ngrx/store';
import {NgForm} from '@angular/forms';
import {ProxyService} from '../../shared/services/proxy.service';
import {FlashMessage} from '../../shared/model/flash-message.model';
import {AddLoading, AddMessage, RemoveLoading} from '../../loading/loading.action';
import {SubSink} from 'subsink';
import {AppState} from '../../store/app.reducer';
import {DialogHide} from './store/send-form.actions';

@Component({
    selector: 'app-send-tag-form',
    templateUrl: './send-form.component.html',
    styleUrls: ['./send-form.component.css']
})
export class SendFormComponent implements OnInit, OnDestroy {

    private subs = new SubSink();

    @ViewChild('f') dialogForm: NgForm;

    public display: boolean;
    public type: number;
    public id: number;
    public typeStr: string;
    public typeName: string;
    public emails: string[];
    public identifier: string;

    constructor(
        private store: Store<AppState>,
        private proxyService: ProxyService
    ) { }

    ngOnInit(): void {
        this.subs.sink = this.store.select('sendTag').subscribe((data) => {
            this.display = data.dialogShow;
            this.type = data.type;
            this.id = data.id;
            this.identifier = data.identifier;

            if (this.type === 1) {
                this.typeStr = 'defect';
            } else if (this.type === 2) {
                this.typeStr = 'task';
            } else if (this.type === 3) {
                this.typeStr = 'goodPractice';
            }
        });
    }

    ngOnDestroy() {
        this.subs.unsubscribe();
    }

    onHide($event: any) {
        this.store.dispatch(new DialogHide());
    }

    onSubmit(f: NgForm) {
        this.store.dispatch(new AddLoading([{name: '@SendingTagLoading', spinner: 'modalLoading'}], 'global'));
        this.proxyService.sendTag(this.type, this.id, this.emails).then((result) => {
            if (result) {
                this.dialogForm.resetForm();
                this.store.dispatch(new AddMessage([FlashMessage.successMessage('emails.tag.sent')], 'global'));
                this.store.dispatch(new DialogHide());
            }
            this.store.dispatch(new RemoveLoading([{name: '@SendingTagLoading', spinner: 'modalLoading'}], 'global'));
        }).catch(() => {
            this.store.dispatch(new RemoveLoading([{name: '@SendingTagLoading', spinner: 'modalLoading'}], 'global'));
        });
    }

    onCancel() {
        this.dialogForm.resetForm();
        this.store.dispatch(new DialogHide());
    }

    validateEmail(event: any) {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/.test(event.value)) {
            return true;
        }

        const index = this.emails.indexOf(event.value);
        if (index !== -1) {
            this.emails.splice(index, 1);
        }

        this.store.dispatch(new AddMessage([FlashMessage.warningMessage('emails.not-an-email-address')], 'global'));
        return false;
    }
}
